<template>
    
    <div :id="_uid" class="ui calendar">
      <div class="ui input left icon" :class="{ disabled }">
        <i class="calendar icon"></i>
        <input class="date" :readonly="readonly">
      </div>
    </div>

</template>

<script>

  import Calendar from "@/utils/calendar"
  
  export default {

    data() {
      return {
        initiated: false,
      }
    },

    props: ["disabled", "readonly", "autoInit"],
    
    mounted() {

      let initCalendar = true

      if (typeof this.autoInit == "boolean")
        initCalendar = this.autoInit

      if (initCalendar)
        this.initCalendar()
    },

    methods: {

      initCalendar() {

        if (this.initiated)
          return
        
        this.initiated = true

        Calendar.init("#" + this._uid, {
          onShow: () => this.readonly ? false : true,
          onChange: (date) => this.$emit("onChange", date),
        })

      },

      setDate(date) {
        $("#" + this._uid).calendar("set date", date)
      },

      clearDate() {
        $("#" + this._uid).calendar("set date", null)
      },
    },
  }
</script>

